import React from 'react';
import { Link } from 'react-router-dom';
import { ClipboardList, ArrowRight } from 'lucide-react';

export default function EleveLivretPage() {
  return (
    <div className="max-w-5xl" data-testid="eleve-livret-page">
      <div className="text-[10.5px] font-black uppercase tracking-[0.22em] text-rose-500 mb-2">Livret d’apprentissage</div>
      <h1 className="text-4xl sm:text-5xl font-black text-white tracking-tight" style={{ fontFamily: "'Playfair Display', Georgia, serif" }}>
        Mon livret
      </h1>
      <p className="text-sm text-white/60 mt-2 mb-6">38 compétences REMC à valider tout au long de ton parcours moto.</p>
      <a href="/livret" target="_blank" rel="noopener noreferrer" data-testid="btn-open-livret-full" className="inline-flex items-center gap-2 px-4 py-3 rounded-xl bg-rose-600 hover:bg-rose-700 text-white font-black text-sm shadow-lg shadow-rose-900/30 transition">
        <ClipboardList className="w-4 h-4" /> Ouvrir le livret complet <ArrowRight size={14} />
      </a>
    </div>
  );
}
